<div class="user-settings-card">
  <!-- HEADER -->
  <div class="header">
    <wm-common-text class="title" [data]="{ text: 'User Settings' }">
    </wm-common-text>

    <!-- <div class="close-area" (click)="onClose()">
      <span class="close-icon">✕</span>
    </div> -->
  </div>

  <!-- CONTENT -->
  <div class="content">
    <!-- USER DETAILS -->
    <wm-common-text class="section-title" [data]="{ text: 'User Details' }">
    </wm-common-text>

    <div class="form-grid">
      <wm-common-textfield
        [data]="{ label: 'Full Name', value: user?.name }"
        (valueChange)="user.name = $event"
      >
      </wm-common-textfield>

      <wm-common-textfield
        [data]="{ label: 'Username', value: user?.userName }"
        (valueChange)="user.userName = $event"
      >
      </wm-common-textfield>

      <wm-common-textfield
        [data]="{ label: 'Email', value: user?.emailAddress }"
        (valueChange)="user.emailAddress = $event"
      >
      </wm-common-textfield>

      <wm-common-textfield
        [data]="{ label: 'Phone', value: user?.phoneNumber }"
        (valueChange)="user.phoneNumber = $event"
      >
      </wm-common-textfield>

  <!-- Added by furkan 17-03-2026 -->
      <wm-common-textfield
        [data]="{ label: 'Street Address', value: user?.address?.address1 }"
        (valueChange)="onAddressChange('address1', $event)"
      >
      </wm-common-textfield>

      <wm-common-textfield
        [data]="{ label: 'Address 2', value: user?.address?.address2 }"
        (valueChange)="onAddressChange('address2', $event)"
      >
      </wm-common-textfield>

      <wm-common-textfield
        [data]="{ label: 'City', value: user?.address?.city }"
        (valueChange)="onAddressChange('city', $event)"
      >
      </wm-common-textfield>

      <wm-common-textfield
        [data]="{ label: 'State', value: user?.address?.state }"
        (valueChange)="onAddressChange('state', $event)"
      >
      </wm-common-textfield>

      <wm-common-textfield
        [data]="{ label: 'Zip', value: user?.address?.zip }"
        (valueChange)="onAddressChange('zip', $event)"
      >
      </wm-common-textfield>
        <!-- ended by furkan 17-03-2026-->
    </div>

    <!-- ROLES HEADER -->
    <div class="roles-header">
      <wm-common-text class="section-title" [data]="{ text: 'Roles' }">
      </wm-common-text>

      <button class="add-role-btn" (click)="openAddRole()">ADD ROLE</button>
    </div>
    <!-- ADD ROLE INLINE PANEL -->
    <div class="add-role-wrapper" *ngIf="isAddRoleOpen">
      <div class="add-role-input-row">
        <input
          type="text"
          class="role-input"
          [(ngModel)]="roleSearch"
          (input)="onRoleSearch()"
          placeholder="Add role to user"
          autocomplete="off"
        />

        <button
          class="primary small"
          [disabled]="!selectedRole || isUserLoading"
          (click)="addSelectedRole()"
        >
          ADD
        </button>

        <button class="secondary small" (click)="cancelAddRole()">
          CANCEL
        </button>
      </div>

      <!-- DROPDOWN (AUTOCOMPLETE STYLE) -->
      <div class="role-dropdown" *ngIf="filteredRoles.length">
        <div
          class="role-option"
          *ngFor="let role of filteredRoles"
          (click)="selectRole(role)"
        >
          {{ role.name }}
        </div>
      </div>
    </div>

    <!-- ROLES GROUPED BY JURISDICTION -->
    <div class="role-group" *ngFor="let group of rolesByCounty">
      <!-- JURISDICTION NAME (GREY TITLE) -->
      <wm-common-text class="group-title" [data]="{ text: group.county }">
      </wm-common-text>

      <div class="roles-grid">
        <div class="role-item" *ngFor="let r of group.roles">
          <wm-common-text class="role-name" [data]="{ text: r.name }">
          </wm-common-text>

          <button type="button" class="remove-btn" [disabled]="isUserLoading" (click)="removeRole(r.id)">
            Remove
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- FOOTER -->
  <div class="footer">
    <button class="secondary" *ngIf="user?.isEnabled" [disabled]="isUserLoading" (click)="disableUser()">
      DISABLE
    </button>

    <!-- ENABLE -->
    <button class="secondary" *ngIf="!user?.isEnabled" [disabled]="isUserLoading" (click)="enableUser()">
      ENABLE
    </button>
    <button
      class="secondary"
      [disabled]="!canResetPassword || isUserLoading"
      (click)="openResetPasswordConfirm()"
    >
      {{ resetPasswordText }}
    </button>

    <button class="primary" [disabled]="isUserLoading" (click)="openSaveConfirm()">SAVE</button>
  </div>
</div>
<wm-common-confirmation-modal
  [data]="confirmationModal"
  (onYesClick)="onConfirmYes()"
  (onOkClick)="onConfirmOk()"
  (onCloseClick)="closeModal()"
  [isApplicantMobileview]="true"
>
</wm-common-confirmation-modal>


